import { createApiRef } from '@mainstage/core-plugin-api';
import { KnowledgeGraphManagerApi } from '@agilelab/plugin-wb-marketplace-common';

/**
 * API reference for the Knowledge Graph Manager API.
 *
 * Defined here (in wb-scaffolder, a frontend-only plugin) rather than in
 * wb-marketplace-common, because wb-marketplace-common is also required at
 * runtime by wb-marketplace-backend. `createApiRef` pulls in
 * `@mainstage/core-plugin-api`'s frontend-only runtime code, which broke the
 * backend's Node module loader when it was bundled into that shared package.
 *
 * wb-marketplace already depends on wb-scaffolder, so it can import this ref
 * from here without creating a circular dependency.
 * @public
 */
export const knowledgeGraphManagerApiRef =
  createApiRef<KnowledgeGraphManagerApi>({
    id: 'plugin.knowledge-graph-manager',
  });
